import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";

import Image from "../../../Partials/Elements/Image/Image";
import { SUBCATEGORY_NDI_CARDS, SUBCATEGORY_NI_CARDS } from "../../../../Utilities/APIs";

import './ImageTitleDescriptionSection.css'
import { useSelector } from "react-redux";

function ImageTitleDescriptionSection({ uniqueClass, ITDCards, subcategory, hasDescription }) {

    const [cards, setCards] = useState(null)
    const { consumer } = useSelector(state => state.auth)
    console.log(ITDCards)
    // console.log(cards)

    useEffect(() => {
        if(uniqueClass === 'NDI'){
            async function getAndSetCards() {
                const cardRes = await fetch(SUBCATEGORY_NDI_CARDS + 'getNDICardsFromSubcategory/' + subcategory)
                const cardData = await cardRes.json()
                setCards(cardData)
            }
    
            getAndSetCards()
        }
        if(uniqueClass === 'NI'){
            async function getAndSetCards() {
                const cardRes = await fetch(SUBCATEGORY_NI_CARDS + 'getNICardsFromSubcategory/' + subcategory)
                const cardData = await cardRes.json()
                setCards(cardData)
            }
    
            getAndSetCards()
        }
    }, [subcategory, uniqueClass])

    return (
        <div className={`image_title_desc ${uniqueClass}`}>
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
            <Swiper
                navigation={{
                    prevEl: `.${uniqueClass} .swiper-button-prev`,
                    nextEl: `.${uniqueClass} .swiper-button-next`
                }}
                slidesPerView={2}
                spaceBetween={18}
                // centeredSlides={true}
                loop={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    }
                }}
                modules={[Autoplay, Navigation]}
            >
                {cards && ITDCards?.map(c => (
                    <SwiperSlide key={c._id}>
                        {
                            cards?.find(card => (card._id === c.subcatNDICard || card._id === c.subcatNICard ))?.image
                                ?
                                <Image
                                    // imgSrc={cards?.find(card => card._id === c.subcatNDICard)?.image}
                                    imgSrc={
                                        uniqueClass=== 'NDI' 
                                        ?
                                        cards?.find(card => card._id === c.subcatNDICard)?.image
                                        :
                                        cards?.find(card => card._id === c.subcatNICard)?.image
                                    }
                                    imgAlt={cards?.find(card => card._id === c.subcatNDICard)?.name}
                                />
                                :
                                <p>
                                    Image Not Found
                                    ({cards?.find(card => card._id === c.subcatNDICard)?.name ? cards?.find(card => card._id === c.subcatNDICard)?.name : 'name not found'})

                                </p>

                        }
                        <h4>
                            {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        cards?.find(card => (card._id === c.subcatNDICard || card._id === c.subcatNICard))?.engName
                                        :
                                        cards?.find(card => (card._id === c.subcatNDICard || card._id === c.subcatNICard))?.name
                                    :
                                    cards?.find(card => (card._id === c.subcatNDICard || card._id === c.subcatNICard))?.name
                            }
                        </h4>
                        {hasDescription && 
                            <p>
                            {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        cards?.find(card => card._id === c.subcatNDICard)?.engDescription
                                        :
                                        cards?.find(card => card._id === c.subcatNDICard)?.description
                                    :
                                    cards?.find(card => card._id === c.subcatNDICard)?.description
                            }
                        </p>
                        }
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default ImageTitleDescriptionSection